import { ReactNode } from 'react';

import { SelectedEmployeeContext } from '~/components/SelectedEmployee/context';
import { useSelectedEmployeeIdState } from '~/hooks/employee';

type PropsType = {
  children?: ReactNode;
};

export const SelectedEmployeeContextRootProvider = (props: PropsType) => {
  const { children } = props;

  const selectedEmployeeIdState = useSelectedEmployeeIdState();

  return (
    <SelectedEmployeeContext.Provider value={selectedEmployeeIdState}>
      {children}
    </SelectedEmployeeContext.Provider>
  );
};
